const getLabelsToRemove = (currentLabels, selectedLabels) => {
  if (!currentLabels) {
    return [];
  }

  return currentLabels.filter((label) => !selectedLabels.includes(label));
};

export default getLabelsToRemove;